<template>
  <div class="awardstreamPage">
    <mu-appbar title="奖金明细">
      <div slot="right" class="title-text" @click="open('top')" >
        <p>筛选 </p>    
        <mu-popup position="top" popupClass="awardstreamPage-popup" :open="topPopup" @close="close('top')">
          <mu-content-block>
            <div class="popuptitle delivery-type-order">
              <div class="button-title">奖金类型</div>
              <div class="button-list">                  
                <mu-flat-button @click="searchTypeChange('')" label="全部" :class="searchInfo.type==''?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange('2')" label="推荐奖金" :class="searchInfo.type=='2'?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange('1')" label="零售奖金" :class="searchInfo.type=='1'?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange('3')" label="批发奖金" :class="searchInfo.type=='3'?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange('4')" label="分红奖金" :class="searchInfo.type=='4'?'demo-flat-button select':'demo-flat-button'"/>
              </div>
            </div>              
          </mu-content-block>
        </mu-popup>      
      </div>
      <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
    </mu-appbar>   
    

      
      <v-scroll :on-refresh="onRefresh" :on-infinite="onInfinite">
        <div class="gd-content">
          <div class="gd-content-tab-dd" id="list"  v-for="(streamItem,index) in streamList" :key="index">
              <dd>
                <table>
                  <tbody>
                    <tr>
                      <td class="first-row" rowspan="2"><img :src="getIconByTraceType('')"></td>
                      <td class="secend-row calcMinus"><span>{{streamItem.award_Desc}}</span>+{{streamItem.award_Amount.toFixed(2)}}</td>
                    </tr>
                    <tr>
                      <td class="one-row "><span style="margin-right:10px;font-size:14px;color:#f18677;">{{ streamItem.typename }}</span>{{streamItem.award_Datename}}</td>
                    </tr>
                  </tbody>
                </table>
              </dd>
          </div>
        </div>
      </v-scroll>
    <XR-toast ref="XRtoast"></XR-toast>
     <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>

<script>
import {ErrorCode} from '../../util/errorcode'
export default {
  data() {
    return {
      loaded :true,
      streamList:[],      
      pageEnd : 0, // 结束页数
      num:15,
      searchInfo:{
        pageIndex : 0, // 开始页数
        pageSize:15,
        type:this.$route.query.type ? this.$route.query.type : ''
      },
      scrollDone:function(){},      
      topPopup: false    
    };
  },
  mounted :function(){
    this.$postBase(
      this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
      ).then(function(res) {
      if(!res.IsSuccess){
          //ths.$refs.XRtoast.failed(res.Msg, true)
      }else{
          wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.Data.AppId, // 必填，公众号的唯一标识
              timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
              nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
              signature: res.Data.Sign, // 必填，签名，见附录1
              jsApiList: [] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
              WeixinJSBridge.call('hideOptionMenu');
          });
      }
    });
    this.$refs.XRtoast.load()
    this.getStreamInfo(true)
  },
  methods: {
    getIconByTraceType:function(traceType){
      return '/static/icon/reward.png'
    },
    getStreamInfo: function(isNewSearch) {
     
      if(isNewSearch){        
        this.searchInfo.pageIndex=1
      }
      else{        
        this.searchInfo.pageIndex++
      }
      var ths = this;   
      ths.$post(
        "/Salesman/SalesmanServer/GetMyAwardStreamPage",this.searchInfo
      ).then(function(res) {
        ths.scrollDone()
        ths.loaded = false
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
          if(isNewSearch){            
             ths.streamList = []
          }      
        }else{       

          if(isNewSearch){
            ths.streamList =res.Data.List
          }
          else{            
            for(var i = 0; i < res.Data.List.length;i++){            
              ths.streamList.push(res.Data.List[i])
            }
           
          }
          ths.pageEnd = res.Data.Rows%ths.num!=0? res.Data.Rows/ths.num+1:res.Data.Rows/ths.num
        }
        if(ths.streamList.length==0){
          ths.$refs.XRPageTip.ShowEmpty('暂无数据')
        }else{
          ths.$refs.XRPageTip.initTip()
        }
      });
    },    
    open (position) {
       
      this[position + 'Popup'] = true
      this.titleIcon = "fa fa-angle-up";
    },
    close (position) {
      this[position + 'Popup'] = false
      this.titleIcon = "fa fa-angle-down";
    },
    searchTypeChange (val) {
        this.searchInfo.type = val
        this.getStreamInfo(true)    
        this.close('top')    
    },
    GoHistory(){
      this.$router.goBack()
    },
    onRefresh(done) {
      //this.getOrderList();
      done() // call done      
    },
    onInfinite(done) {      
      this.scrollDone = done
      if(this.searchInfo.pageIndex+1 > this.pageEnd){
        done()
        this.$refs.XRtoast.failed("已经到最后一页", true)
        return
      }
      this.getStreamInfo(false);     
    }
  }
};
</script>
<style>
*{
  margin: 0;
  padding: 0;
}
body .awardstreamPage{
  background: white;
  overflow: hidden;
}
.awardstreamPage .yo-scroll{
  background: white;
  top:56px;
}

.awardstreamPage .mu-appbar{
    position: fixed;
    top: 0;
    z-index: 20180101;
}
.awardstreamPage .mu-appbar-title {
    font-size: 16px;
}
.awardstreamPage .right .title-text{
    font-size: 16px;
}

body .awardstreamPage #list{
  padding-top: 10px;
}
body .awardstreamPage .gd-content{
  background: white;
  overflow: hidden;
}
    .awardstreamPage .gd-content table {
        width:96%;
    }
    .awardstreamPage .gd-content table td {
        vertical-align:middle;
    }
        .awardstreamPage .gd-content table td.first-row {
            padding-top:5px;
            width:48px;
            line-height:16px;
            text-align: center;
        }
           .awardstreamPage  .gd-content table td.first-row img {
                width:28px;                
            }

       .awardstreamPage  .gd-content table td.secend-row {
            padding-top:17px;
            line-height:14px;
            text-align:right;
            font-style:normal;
        }
       .awardstreamPage  .gd-content table td.secend-row span{
            float:left;
            color:#8F94A1;
        }
        .awardstreamPage .gd-content table td.one-row {
            padding-bottom:17px;
            border-bottom:1px solid #F6F6F6;
            line-height:14px;
            color:#CDCDCD;
            font-size:12px;
        }
           .awardstreamPage  .gd-content table td.one-row.last {
                border:none;
            }

.awardstreamPage .calcPlus {
    color:red;
}
.awardstreamPage .calcMinus {
    color:#59C2A4;
}

.awardstreamPage .coin-info {
    padding:5px 0 20px;
    text-align:center;
}
    .awardstreamPage .coin-info .balance {
        font-size:24px;
    }
    .awardstreamPage .coin-info .balance-title {
        font-size:12px;
        color:#999;
        padding-top:4px;
    }

    .awardstreamPage-popup {
        width: 100%;
        top:46px;
        height: 360px;
        z-index: 1;
        padding: 20px 0;
    }
    .awardstreamPage-popup .popuptitle .title{
        overflow: hidden;
    }
    .awardstreamPage-popup .popuptitle .button-title{
      padding: 20px 20px 10px;
    }
    .awardstreamPage-popup .popuptitle .title .text{
        float: left; 
        width:20%;
        text-align: center;
        line-height: 24px;
        color:#ccc;
    }
    .awardstreamPage-popup .popuptitle .title .line{
        float: left; 
        height: 1px;
        background:#eee;
        width: 80%;
        border: none;
        margin-top: 10px;
    }
    .awardstreamPage-popup .popuptitle .demo-flat-button.select{
      color:red;
    }
</style>



// WEBPACK FOOTER //
// src/pages/salesman/awardstream.vue